// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".gpay-card-info-container.black, .gpay-button.black {\n    outline: none !important; \n}", ""]);
// Exports
module.exports = exports;
